import React from 'react'
import { REGIMENES_LIST } from '../core/engine/regimenesEspeciales'

const REGIMEN_COLORS = {
  COMUN: 'bg-emerald-400',
  DOCENTE: 'bg-sky-400',
  INSALUBRE: 'bg-amber-400',
  CONSTRUCCION: 'bg-orange-400',
  AGRARIO: 'bg-lime-400',
  SERVICIO_DOMESTICO: 'bg-violet-400',
}

function renderDiasCell(r, updateRowField) {
  const rawDias = r.diasOrigen ?? r.diasComputables
  const hasDias = rawDias !== null && rawDias !== undefined && String(rawDias).trim() !== ''
  const diasValue = hasDias ? Number(rawDias) : ''
  const isIncompleto = hasDias && Number.isFinite(diasValue) && diasValue > 0 && diasValue < 30
  const sinDato = !hasDias
  return (
    <div className="flex flex-col gap-1">
      <input
        type="number"
        min="0"
        max="30"
        value={hasDias && Number.isFinite(diasValue) ? diasValue : ''}
        onChange={(e) => updateRowField(r._rowId, 'diasOrigen', e.target.value)}
        className="h-8 w-20 rounded border border-white/20 bg-slate-900/60 px-2"
        placeholder="-"
      />
      {isIncompleto && (
        <span className="text-[10px] text-amber-200">Incompleto</span>
      )}
      {sinDato && (
        <span className="text-[10px] text-slate-400">Sin dato OCR</span>
      )}
    </div>
  )
}

function renderBadges(r, asistidoMode) {
  const badges = []

  if (r.isMoratoriaRow) {
    badges.push(
      <span key="moratoria" className="ml-2 inline-flex rounded-full border border-cyan-300/60 bg-cyan-500/20 px-2 py-0.5 text-[10px] text-cyan-100">Moratoria (fuera de promedio PC/PAP)</span>
    )
  }
  if (r.isAutonomoRow) {
    badges.push(
      <span key="autonomo" className="ml-2 inline-flex rounded-full border border-fuchsia-300/60 bg-fuchsia-500/20 px-2 py-0.5 text-[10px] text-fuchsia-100">Autónomo</span>
    )
  }
  if (r.requiresMacklerReview) {
    badges.push(
      <span key="mackler" className="ml-2 inline-flex rounded-full border border-rose-300/60 bg-rose-500/20 px-2 py-0.5 text-[10px] text-rose-100">Revisar Mackler</span>
    )
  }
  if (r.manualAdded) {
    badges.push(
      <span key="manualAdded" className="ml-2 inline-flex rounded-full border border-amber-300/50 bg-amber-500/25 px-2 py-0.5 text-[10px] text-amber-100">Periodo agregado manualmente</span>
    )
  }
  if (r.manualEdited && !r.manualAdded) {
    badges.push(
      <span key="manualEdited" className="ml-2 inline-flex rounded-full border border-amber-300/50 bg-amber-500/20 px-2 py-0.5 text-[10px] text-amber-100">Periodo ajustado manualmente</span>
    )
  }
  if (r.missingInSource && !r.manualAdded && !r.manualEdited) {
    badges.push(
      <span key="missing" className="panel-profile-warn ml-2 inline-flex rounded-full px-2 py-0.5 text-[10px] text-profile-warn">No ANSES / Manual</span>
    )
  }
  if (!r.missingInSource && r.estadoIdentidad) {
    if (asistidoMode && r.estadoIdentidad === 'INFERRED') {
      badges.push(
        <span
          key="identidad"
          title="Fila con datos incompletos — revisá los campos en rojo"
          className="ml-2 inline-flex rounded-full border px-2 py-0.5 text-[10px] panel-profile-warn text-profile-warn"
        >
          Fila con datos incompletos — revisá los campos en rojo
        </span>
      )
    } else if (asistidoMode && r.estadoIdentidad === 'CORRUPT') {
      badges.push(
        <span
          key="identidad"
          title="Esta fila tiene errores de carga — revisala antes de continuar"
          className="ml-2 inline-flex rounded-full border px-2 py-0.5 text-[10px] panel-profile-danger text-profile-danger"
        >
          Esta fila tiene errores de carga — revisala antes de continuar
        </span>
      )
    } else {
      badges.push(
        <span
          key="identidad"
          title={`Estado ${r.estadoIdentidad} - confianza ${Number(r.confianzaIdentidad || 0)}%`}
          className={`ml-2 inline-flex rounded-full border px-2 py-0.5 text-[10px] ${r.estadoIdentidad === 'FACTUAL' ? 'panel-profile-ok text-profile-ok' : r.estadoIdentidad === 'INFERRED' ? 'panel-profile-warn text-profile-warn' : 'panel-profile-danger text-profile-danger'}`}
        >
          {r.estadoIdentidad}
        </span>
      )
    }
  }
  if (r.reviewSeverity === 'critical') {
    badges.push(
      <span key="critical" className="ml-2 inline-flex rounded-full border border-rose-300/60 bg-rose-500/25 px-2 py-0.5 text-[10px] text-rose-100">Error grave</span>
    )
  }
  if (r.reviewSeverity === 'verify') {
    badges.push(
      <span key="verify" className="ml-2 inline-flex rounded-full border border-amber-300/60 bg-amber-500/25 px-2 py-0.5 text-[10px] text-amber-100">Verificar</span>
    )
  }
  if (r.reviewSeverity === 'ok') {
    badges.push(
      <span key="ok" className="ml-2 inline-flex rounded-full border border-emerald-300/50 bg-emerald-500/20 px-2 py-0.5 text-[10px] text-emerald-100">OK</span>
    )
  }
  if (r.topeInaplicablePorConfiscatoriedad) {
    badges.push(
      <span
        key="tope-inaplicable"
        title={`Quita por tope detectada: ${Number(r.quitaPorTopePeriodoPct || 0).toFixed(2)}%`}
        className="ml-2 inline-flex rounded-full border border-rose-300/60 bg-rose-500/25 px-2 py-0.5 text-[10px] text-rose-100"
      >
        Tope inaplicable ({Number(r.quitaPorTopePeriodoPct || 0).toFixed(2)}%)
      </span>
    )
  }
  if (!r.topeInaplicablePorConfiscatoriedad && Number(r.quitaPorTopePeriodoPct || 0) > 0) {
    badges.push(
      <span
        key="tope-aplicado"
        title="Quita por tope dentro del umbral configurado"
        className="ml-2 inline-flex rounded-full border border-amber-300/60 bg-amber-500/25 px-2 py-0.5 text-[10px] text-amber-100"
      >
        Tope aplicado ({Number(r.quitaPorTopePeriodoPct || 0).toFixed(2)}%)
      </span>
    )
  }
  if (r.isEstimatedIndex) {
    badges.push(
      <span key="estimated" className="panel-profile-warn ml-2 inline-flex rounded-full px-2 py-0.5 text-[10px] text-profile-warn">IPC Estimado</span>
    )
  }
  return badges
}

export default function YearlyLaborTable({
  reviewTab, groupedByYearFiltered, expandedYears,
  setExpandedYears, updateRowField, reviewMode, removeRevisionRow,
  asistidoMode,
}) {
  if (reviewTab !== 'edicion') return null

  return (
    <>
      {groupedByYearFiltered.map(([year, items]) => (
        <details
          key={`year-${year}`}
          open={Boolean(expandedYears[year])}
          onToggle={(e) => {
            const isOpen = Boolean(e?.currentTarget?.open)
            setExpandedYears((p) => ({ ...p, [year]: isOpen }))
          }}
          className="rounded-lg border border-white/15 bg-white/5"
        >
          <summary className="cursor-pointer px-3 py-2 text-sm font-semibold text-profile-accent">
            <span className="inline-flex items-center gap-2">
              <span>Año {year} - {items.length} registros</span>
              {items.some((r) => r.manualAdded || r.manualEdited || r.missingInSource || r.requiresValidation || r.requiereRevision || r.topeInaplicablePorConfiscatoriedad) && (
                <span title="Este año tiene filas a revisar" className="inline-flex h-4 w-4 items-center justify-center rounded-full border border-amber-300/60 bg-amber-500/30 text-[10px] text-amber-100">!</span>
              )}
            </span>
          </summary>
          <div className="overflow-x-auto px-3 pb-3">
            <table className="min-w-full text-xs text-slate-100">
              <thead>
                <tr className="text-slate-300">
                  <th className="px-2 py-1 text-left">Periodo</th>
                  <th className="px-2 py-1 text-left">Régimen</th>
                  <th className="px-2 py-1 text-left">Dias</th>
                  <th className="px-2 py-1 text-left">Empresa</th>
                  <th className="px-2 py-1 text-left">CUIT</th>
                  <th className="px-2 py-1 text-left">Monto bruto</th>
                  <th className="px-2 py-1 text-left">SAC</th>
                  <th className="px-2 py-1 text-left">Monto computable</th>
                  <th className="px-2 py-1 text-left">Accion</th>
                </tr>
              </thead>
              <tbody>
                {items.map((r) => (
                  <tr key={`row-${r._rowId || r._idx}`} className={`border-t border-white/10 ${r.manualAdded ? 'bg-amber-400/25' : r.manualEdited ? 'bg-amber-500/20' : r.missingInSource ? 'bg-rose-500/20' : ''}`}>
                    <td className="px-2 py-1">
                      <input type="month" value={r.periodoISO || ''} onChange={(e) => updateRowField(r._rowId, 'periodo', e.target.value)} className="h-8 w-36 rounded border border-white/20 bg-slate-900/60 px-2" />
                    </td>
                    <td className="px-2 py-1">
                      <div className="flex items-center gap-1">
                        <span className={`inline-block h-2 w-2 rounded-full ${REGIMEN_COLORS[r.regimenContributivo] || 'bg-slate-400'}`} />
                        <select
                          value={r.regimenContributivo || 'COMUN'}
                          onChange={(e) => updateRowField(r._rowId || r.rowId, 'regimenContributivo', e.target.value)}
                          className="h-8 w-32 rounded border border-white/20 bg-slate-900/60 px-1 text-[11px]"
                        >
                          {REGIMENES_LIST.map((reg) => (
                            <option key={reg.id} value={reg.id.toUpperCase()}>{reg.labelEs}</option>
                          ))}
                        </select>
                      </div>
                    </td>
                    <td className="px-2 py-1">
                      {renderDiasCell(r, updateRowField)}
                    </td>
                    <td className="px-2 py-1">
                      <input value={r.empresa || ''} onChange={(e) => updateRowField(r._rowId, 'empresa', e.target.value)} className="h-8 w-44 rounded border border-white/20 bg-slate-900/60 px-2" />
                      {renderBadges(r, asistidoMode)}
                      {reviewMode === 'perito' && r.dobleEmpleo && Array.isArray(r.detalleSimultaneidad) && r.detalleSimultaneidad.length > 1 && (
                        <div className="mt-1 text-[11px] text-profile-warn">[+] Simultaneidad consolidada: {r.detalleSimultaneidad.map((d) => `${d.empresa} $${Number(d.monto || 0).toLocaleString('es-AR')}`).join(' | ')}</div>
                      )}
                    </td>
                    <td className="px-2 py-1"><input value={r.cuit || ''} onChange={(e) => updateRowField(r._rowId, 'cuit', e.target.value)} className="h-8 w-36 rounded border border-white/20 bg-slate-900/60 px-2" /></td>
                    <td className="px-2 py-1"><input type="text" inputMode="decimal" value={Number(r.montoDeclarado ?? r.monto ?? 0)} onChange={(e) => updateRowField(r._rowId, 'montoDeclarado', e.target.value)} className="h-8 w-36 rounded border border-white/20 bg-slate-900/60 px-2" /></td>
                    <td className="px-2 py-1">
                      {(String(r.periodoKey || '').endsWith('-06') || String(r.periodoKey || '').endsWith('-12')) ? (
                        <div className="flex flex-col gap-1">
                          <label className="inline-flex items-center gap-1 text-[10px] text-slate-200">
                            <input type="checkbox" checked={Boolean(r.incluyeSac)} onChange={(e) => updateRowField(r._rowId, 'incluyeSac', e.target.checked)} /> Incluye SAC
                          </label>
                          {Boolean(r.incluyeSac) && (
                            <input type="text" inputMode="decimal" value={Number(r.sacManual || 0)} onChange={(e) => updateRowField(r._rowId, 'sacManual', e.target.value)} placeholder="SAC manual (opt.)" className="h-8 w-36 rounded border border-white/20 bg-slate-900/60 px-2 text-[11px]" />
                          )}
                        </div>
                      ) : <span className="text-[11px] text-slate-400">No aplica</span>}
                    </td>
                    <td className="px-2 py-1">
                      <span className="font-semibold text-emerald-200">${Number(r.monto || r.remImpSS || 0).toLocaleString('es-AR')}</span>
                      {Boolean(r.sacAplicado) && <span className="ml-2 inline-flex rounded-full border border-amber-300/50 bg-amber-500/20 px-2 py-0.5 text-[10px] text-amber-100">SAC descontado una vez</span>}
                    </td>
                    <td className="px-2 py-1">
                      <button
                        type="button"
                        onClick={() => removeRevisionRow(r._rowId)}
                        className="rounded border border-rose-300/40 bg-rose-500/20 px-2 py-1 text-[11px] text-rose-100"
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </details>
      ))}
    </>
  )
}
